export default __webpack_public_path__ + "static/media/2435.d05fc1f6.png";